import type { IconProps } from './types';

export const FormatIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.51313 6.01992C5.86953 5.16403 6.69586 4.60002 7.61763 4.6C8.60068 4.6 9.47485 5.2418 9.78658 6.19473L12.3159 13.9242C12.3201 13.9362 12.3243 13.9501 12.3276 13.9613L13.7593 18.3363L13.7807 18.4164C13.8632 18.7905 13.6743 19.1722 13.3335 19.3285L13.2583 19.3588C12.8714 19.49 12.4534 19.2991 12.2885 18.9252L12.2593 18.848L11.0249 15.0746L11.0024 15.0053H4.23383L4.21137 15.0746L2.97601 18.848C2.84596 19.2456 2.44392 19.4704 2.05413 19.3812L1.97698 19.3588C1.56351 19.2183 1.33706 18.761 1.47601 18.3363L2.90863 13.9594C2.90966 13.956 2.91072 13.9524 2.91181 13.9487C2.91454 13.9394 2.91743 13.9295 2.92035 13.9213L5.44868 6.19473L5.51313 6.01992ZM7.61763 6.21523C7.92246 6.21523 8.19104 6.41442 8.28658 6.70645L10.4311 13.2592L10.4731 13.39H4.76215L4.80512 13.2592L6.94868 6.70645L6.99165 6.60098C7.11131 6.36736 7.35095 6.21526 7.61763 6.21523Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5932 11.9125C14.5932 9.66615 16.3777 7.85012 18.5776 7.85C20.7777 7.85 22.563 9.66608 22.563 11.9125V18.5932C22.5628 19.0408 22.2067 19.4008 21.772 19.4008C21.3372 19.4008 20.9812 19.0408 20.981 18.5932V18.3783L20.8247 18.4857C20.5389 18.6814 20.2484 18.8347 19.9702 18.9545L19.6958 19.0639C19.3528 19.1896 19.0332 19.2678 18.7671 19.3168L18.52 19.3568L18.1509 19.3939C18.1286 19.3953 18.1084 19.3961 18.0903 19.3969L17.8892 19.3949C16.1727 19.3471 14.5935 18.0813 14.5932 16.2807C14.5932 14.4446 16.2349 13.1605 17.9897 13.1605H18.4097C19.3011 13.1605 20.1985 12.8677 20.9399 12.3354L20.981 12.3051V11.9125C20.981 10.5616 19.9079 9.46523 18.5776 9.46523C17.2475 9.46536 16.1743 10.5617 16.1743 11.9125C16.1742 12.3601 15.8181 12.7201 15.3833 12.7201C14.9487 12.7199 14.5933 12.3599 14.5932 11.9125ZM20.981 15.9174L20.9712 15.9379C20.5949 16.7282 19.9954 17.1805 19.4106 17.4428L19.1616 17.5434C18.914 17.6342 18.6814 17.6912 18.4878 17.727L18.3081 17.7562L18.0561 17.7816C18.0286 17.7834 18.0084 17.7843 17.9966 17.7846L17.9849 17.7855C16.8812 17.7833 16.1746 17.0098 16.1743 16.2807C16.1743 15.5503 16.8831 14.7748 17.9897 14.7748H18.4097C19.2437 14.7748 20.0753 14.5899 20.8394 14.2416L20.981 14.1771V15.9174Z"
        fill={color}
      />
    </svg>
  );
};
